<template>
  <div class="today-task-container">
    <div class="task-bar" v-for="(item, index) in barList" :key="index">
      <a-tooltip>
        <template slot="title"> {{ item.label }} </template>
        <div class="label" @click="jump(item)">{{ item.label }}</div>
      </a-tooltip>

      <div class="bar" v-if="colors.length">
        <div
          @click="jump(item)"
          class="bar-inner"
          :style="{ width: `${computePercent(item.value)}%`,backgroundImage: `linear-gradient(to right, ${colors[0]}, ${colors[1]})` }"
        >
        </div>
      </div>
      <div class="number">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    colors: Array,
    classData: Object
  },
  data() {
    return {
      total: 0,
      barList: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    computePercent(num) {
      if (this.total === 0) return 0
      let percent = (num / this.total) * 100
      return percent.toString().substr(0, 4)
    },

    jump(item) {
      this.$router.push({ name: 'site_info', query: { spiderId: item.code, type: item.type || 'news' } })
    },
    getType(spiderId) {
      if (spiderId == null || spiderId == undefined) {
        return
      }
      var type = spiderId.split('_')[1]
      if (this.classData[type]) {
        return type
      } else {
        return
      }
    },
    init() {
      let that = this

      this.data.forEach((rank) => {
        this.barList.push({
          label: rank['spiderName'],
          value: rank['cnt'],
          code: rank['spiderId'],
          type: that.getType(rank['spiderId'])
        })
      })

      this.barList.filter((bar) => bar.value !== undefined && bar.type !== undefined)
      this.total = this.barList.reduce((t, c) => t + c.value, 0)
    }
  },
  watch: {
    data() {
      this.init()
    },
    classMap() {
      this.init()
    }
  }
}
</script>


<style lang="less" scoped>
.today-task-container {
  width: 100%;
  height: 370px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .task-bar {
    height: 14px;
    line-height: 14px;
    display: flex;
    cursor: pointer;
    .label {
      width: 60px;
      color: #333;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .bar {
      flex: 1;
      height: 100%;
      border-radius: 10px;
      margin: 0 20px;

      .bar-inner {
        /*min-width: 60px;*/
        line-height: 14px;
        height: 100%;
        border-radius: 10px;
        background-image: linear-gradient(to right, #6ab0e4, #d7efff);
      }
    }

    .number {
      width: 50px;
      margin-right: 50px;
    }
  }
}
</style>
